import React from 'react';
import FormProgress from './FormProgress';
import FormNavigation from './FormNavigation';
import AutosaveIndicator from './AutosaveIndicator';
import ResumeForm from './ResumeForm';
import { CheckCircleIcon } from 'lucide-react';
interface Step {
  id: string;
  title: string;
}
interface IntakeFormLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  title: string;
  onNext: () => void;
  onBack: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  steps?: Step[];
}
const IntakeFormLayout: React.FC<IntakeFormLayoutProps> = ({
  children,
  currentStep,
  totalSteps,
  title,
  onNext,
  onBack,
  isFirstStep,
  isLastStep,
  steps = []
}) => {
  return <div className="min-h-screen bg-slate-50" data-id="element-186">
      {/* Header */}
      <header className="bg-navy-800 text-white py-6 shadow-md" data-id="element-187">
        <div className="container mx-auto px-4 md:px-6" data-id="element-188">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-189">
            <div data-id="element-190">
              <h1 className="text-2xl font-semibold" data-id="element-191">
                Estate Planning Intake Form
              </h1>
              <p className="text-slate-300 mt-1" data-id="element-192">
                Complete your Will and Power of Attorney questionnaire
              </p>
            </div>
            <div className="mt-4 md:mt-0 flex items-center" data-id="element-193">
              <AutosaveIndicator data-id="element-194" />
              <div className="ml-4" data-id="element-195">
                <ResumeForm data-id="element-196" />
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Progress Bar */}
      <div className="container mx-auto px-4 md:px-6 pt-6" data-id="element-197">
        <FormProgress currentStep={currentStep} totalSteps={totalSteps} data-id="element-198" />
      </div>
      {/* Main Content with Sidebar */}
      <main className="container mx-auto px-4 md:px-6 py-8" data-id="element-199">
        <div className="flex flex-col lg:flex-row gap-6" data-id="element-200">
          {/* Sidebar - Hidden on mobile, visible on desktop */}
          {steps.length > 0 && <aside className="hidden lg:block lg:w-64 flex-shrink-0" data-id="element-201">
              <div className="bg-white rounded-lg shadow-md p-4 sticky top-6" data-id="element-202">
                <h3 className="text-sm font-semibold text-navy-900 mb-4 uppercase tracking-wide" data-id="element-203">
                  Form Sections
                </h3>
                <nav className="space-y-1" data-id="element-204">
                  {steps.map((step, index) => {
                const isActive = index === currentStep;
                const isCompleted = index < currentStep;
                return <div key={step.id} className={`flex items-start py-2 px-3 rounded-md transition-colors ${isActive ? 'bg-navy-50 border-l-4 border-navy-600' : isCompleted ? 'bg-slate-50' : 'hover:bg-slate-50'}`} data-id="element-205">
                        <div className="flex items-center flex-1 min-w-0" data-id="element-206">
                          <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium mr-3 ${isActive ? 'bg-navy-600 text-white' : isCompleted ? 'bg-green-100 text-green-700' : 'bg-slate-200 text-slate-600'}`} data-id="element-207">
                            {isCompleted ? <CheckCircleIcon size={14} data-id="element-208" /> : index + 1}
                          </div>
                          <span className={`text-sm ${isActive ? 'font-medium text-navy-900' : isCompleted ? 'text-slate-700' : 'text-slate-600'}`} data-id="element-209">
                            {step.title}
                          </span>
                        </div>
                      </div>;
              })}
                </nav>
              </div>
            </aside>}
          {/* Form Content */}
          <div className="flex-1 min-w-0" data-id="element-210">
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-211">
              <h2 className="text-2xl font-semibold text-navy-900 mb-6" data-id="element-212">
                {title}
              </h2>
              {children}
            </div>
          </div>
        </div>
      </main>
      {/* Navigation */}
      <div className="sticky bottom-0 bg-white border-t border-slate-200 py-4 px-4 md:px-6 shadow-md" data-id="element-213">
        <div className="container mx-auto" data-id="element-214">
          <FormNavigation onNext={onNext} onBack={onBack} isFirstStep={isFirstStep} isLastStep={isLastStep} data-id="element-215" />
        </div>
      </div>
    </div>;
};
export default IntakeFormLayout;